export default {
  frontRoutes: [
    {
      path: '/homework/intro',
      name: 'HomeworkIntro',
      component: () =>
        import(
          /* webpackChunkName: "homework" */
          '../views/homework/HomeworkIntro.vue'
        ),
      meta: {
        requireAuth: true,
        title: '作业详情',
      },
    },
    {
      path: '/homework/analysis',
      name: 'HomeworkAnalysis',
      component: () =>
        import(
          /* webpackChunkName: "homework" */
          '../views/homework/HomeworkAnalysis.vue'
        ),
      meta: {
        requireAuth: true,
        title: '作业详情',
      },
    },
    {
      path: '/homework/do',
      name: 'HomeworkDo',
      component: () =>
        import(
          /* webpackChunkName: "homework" */
          '../views/homework/HomeworkDo.vue'
        ),
      meta: {
        requireAuth: true,
        title: '作业答题',
      },
    },
  ],
  memberRoutes: [
    {
      path: '/member/homework-index',
      name: 'MemberHomeworkIndex',
      component: () =>
        import(
          /* webpackChunkName: "homework" */
          '../views/homework/MemberHomeworkIndex.vue'
        ),
      meta: {
        requireAuth: true,
        title: '我的作业',
        root: true,
      },
    },
  ],
};
